import { get } from 'lodash';

import Model from 'models';

const Level3Node = class extends Model {
  get id() {
    return get(this._data, 'id');
  }

  get label() {
    return get(this._data, 'labelV2');
  }

  get linkUrl() {
    return get(this._data, 'linkUrl');
  }

  get image() {
    return get(this._data, 'imageV2');
  }
};

export default Level3Node;
